import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { MediaImage_Fragment } from "./mediaimage";
// import { Video_Fragment } from "./video";

export const MediaConnectionMasked_Fragment = graphqlShopifyStorefront(
  `
  fragment MediaConnectionMasked on MediaConnection {
    edges {
      node {
        __typename
        ...MediaImage
        ...Video
      }
    }
  }
`,
  // [MediaImage_Fragment, Video_Fragment],
);
